import { useSelector } from 'react-redux';
import { selectIsIterableGoalsStretchFlagOn } from 'core/userContext';
import { tabs } from 'modules/iterableGoals/constants';
import { useTabContext } from 'modules/iterableGoals/contexts';
import { useGoalsTranslations } from 'modules/iterableGoals/hooks';
import { AnalyticsTabs } from 'modules/iterableGoals/types';
import { AnalyticsTimeRangeHeader, GoalAnalyticsHeader } from './sections';
import {
  ContentWrapper,
  FullWidthPageContainer,
  PageBodyBackground,
  PageHeaderBackground,
  StyledTab,
  StyledTabGroup,
  TabPanel,
} from './Styled';
import { CurrentTab } from './tabs/CurrentTab';

export const GoalAnalyticsPage = () => {
  const isIterableGoalsStretchFlagOn = useSelector(selectIsIterableGoalsStretchFlagOn);
  const { selectedTab, setSelectedTab } = useTabContext();
  const { t } = useGoalsTranslations();

  return (
    <FullWidthPageContainer>
      <PageHeaderBackground>
        <ContentWrapper>
          <GoalAnalyticsHeader />
          <StyledTabGroup
            data-test="goal-analytics-tabs"
            selectedTab={selectedTab}
            onTabChange={setSelectedTab}
          >
            {tabs
              .filter(({ id }) => isIterableGoalsStretchFlagOn || id !== AnalyticsTabs.CAMPAIGNS)
              .map(({ id, label }) => (
                <StyledTab
                  data-test={`goal-analytics-${id}-tab-header`}
                  key={id}
                  squareTheme
                  id={id}
                  label={t(label)}
                />
              ))}
          </StyledTabGroup>
        </ContentWrapper>
      </PageHeaderBackground>
      <PageBodyBackground>
        <ContentWrapper>
          <AnalyticsTimeRangeHeader />
          <TabPanel>
            <CurrentTab selectedTab={selectedTab} />
          </TabPanel>
        </ContentWrapper>
      </PageBodyBackground>
    </FullWidthPageContainer>
  );
};
